module.exports = __webpack_public_path__ + "static/media/pink-white-flower-small.3424a973.jpg";